import React, { useEffect, useState } from "react";
import _, { get } from "lodash";
import { OceanJourneyTab, AirJourneyTab } from "UI-Common-Lib"
import { Icon, Loader, Message } from "semantic-ui-react";
import './journey-tab.scss'
import { getJourneyDetails } from "../../apiCalls/journeyDetails";
const JourneyTab = ({shipmentId,mot,mbol}) => {
  const [journeyTabData, setJourneyTabData] = useState(null);
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [isDataFetched, setIsDataFetched] = useState(false)

  useEffect(() => {
    getJourneyDetails({ shipmentId, mbol }).then((res) => {
      let data = get(res, "data.eventMessage", "");
      if (!_.isEmpty(get(data,"stops",[])) && get(data,'stops',[]).length > 0){
        setJourneyTabData(data);
      }
      else {
        setError("No data found for this MBOL")
      }
      setIsDataFetched(true)
    }).catch((error) => {
      setError("Error fetching journey details")
      console.log("Error fetching data",error);
      setIsLoading(false)
    }).finally(() => {
      setIsLoading(false)
    })
  }, []);

  return (
    <>
      {isLoading ? (
        <div style={{marginTop:'100px'}}>
          <Loader active>Fetching Data</Loader>
        </div>
      ) : (
        <div style={{ overflow: "auto" }}>
          {error ? (isDataFetched ? 
            <Message 
              info
              icon={<Icon name="info circle" size="large"/>}
              style={{margin:"auto",width:"60%"}}
              content={error}
            /> : (
            <Message 
              negative
              icon={<Icon name="info circle" size="large"/>}
              style={{margin:"auto",width:"60%"}}
              content={error}
            /> )
            ) : 
            (journeyTabData ? ((mot === "OCEAN") ? <OceanJourneyTab source="OPS" journeyTabData={journeyTabData} /> : (mot === "AIR") ? <AirJourneyTab source="OPS" journeyTabData={journeyTabData}/> : (
            <Message 
              info
              icon={<Icon name="info circle" size="large"/>} 
              content={"Journey not available for this MOT"}
              style={{width:"60%",margin:"auto"}}
            />)): <Message 
              info
              icon={<Icon name="info circle" size="large"/>} 
              content={error}
              style={{width:"60%",margin:"auto"}}
            />)}
        </div>)
      } 
      
    </>
  );
}

export default React.memo(JourneyTab)
